export default {
    "100416529": {
        "Count": 3,
        "Components": {
            "1077065191": { "Name": "WCT_VAR_WOOD", "Desc": "WCD_VAR_WOOD", "Price": 3000, "Type": 1 },
            "2805810788": { "Name": "WCT_SUPP", "Desc": "WCD_AR_SUPP2", "Price": 1800, "Type": 3 },
            "3159677559": { "Name": "WCT_SCOPE_MAX", "Desc": "WCD_SCOPE_MAX", "Price": 2300, "Type": 4 },
            "3527687644": { "Name": "WCT_SCOPE_LRG", "Desc": "WCD_SCOPE_LRG", "Price": 2500, "Type": 4 }
        }
    },
    "171789620": {
        "Count": 3,
        "Components": {
            "202788691": { "Name": "WCT_GRIP", "Desc": "WCD_GRIP", "Price": 900, "Type": 8 },
            "2076495324": { "Name": "WCT_FLASH", "Desc": "WCD_FLASH", "Price": 1200, "Type": 7 },
            "2855028148": { "Name": "WCT_SCOPE_SML", "Desc": "WCD_SCOPE_SML", "Price": 1500, "Type": 4 }
        }
    },
    "324215364": {
        "Count": 4,
        "Components": {
            "899381934": { "Name": "WCT_FLASH", "Desc": "WCD_FLASH", "Price": 800, "Type": 7 },
            "1215999497": { "Name": "WCT_VAR_GOLD", "Desc": "WCD_VAR_GOLD", "Price": 900, "Type": 1 },
            "2637152041": { "Name": "WCT_SCOPE_MAC", "Desc": "WCD_SCOPE_MAC", "Price": 1100, "Type": 4 },
            "2805810788": { "Name": "WCT_SUPP", "Desc": "WCD_AR_SUPP2", "Price": 1000, "Type": 3 }
        }
    },
    "453432689": {
        "Count": 3,
        "Components": {
            "899381934": { "Name": "WCT_FLASH", "Desc": "WCD_FLASH", "Price": 400, "Type": 7 },
            "1709866683": { "Name": "WCT_SUPP", "Desc": "WCD_PI_SUPP", "Price": 600, "Type": 3 },
            "3610841222": { "Name": "WCT_VAR_GOLD", "Desc": "WCD_VAR_GOLD", "Price": 500, "Type": 1 }
        }
    },
    "487013001": {
        "Count": 3,
        "Components": {
            "2076495324": { "Name": "WCT_FLASH", "Desc": "WCD_FLASH", "Price": 500, "Type": 7 },
            "2732039643": { "Name": "WCT_VAR_GOLD", "Desc": "WCD_VAR_GOLD", "Price": 600, "Type": 1 },
            "3859329886": { "Name": "WCT_SUPP", "Desc": "WCD_SR_SUPP", "Price": 700, "Type": 3 }
        }
    },
    "584646201": {
        "Count": 3,
        "Components": {
            "899381934": { "Name": "WCT_FLASH", "Desc": "WCD_FLASH", "Price": 900, "Type": 7 },
            "2608252716": { "Name": "WCT_VAR_METAL", "Desc": "WCD_VAR_METAL", "Price": 1000, "Type": 1 },
            "3271853210": { "Name": "WCT_SUPP", "Desc": "WCD_PI_SUPP", "Price": 1100, "Type": 3 }
        }
    },
    "736523883": {
        "Count": 4,
        "Components": {
            "202788691": { "Name": "WCT_GRIP", "Desc": "WCD_GRIP", "Price": 900, "Type": 8 },
            "663170192": { "Name": "WCT_VAR_GOLD", "Desc": "WCD_VAR_GOLD", "Price": 900, "Type": 1 },
            "1019656791": { "Name": "WCT_SCOPE_MAC", "Desc": "WCD_SCOPE_MAC", "Price": 1100, "Type": 4 },
            "2076495324": { "Name": "WCT_FLASH", "Desc": "WCD_FLASH", "Price": 1200, "Type": 7 },
            "2637152041": { "Name": "WCT_SCOPE_MAC", "Desc": "WCD_SCOPE_MAC", "Price": 1100, "Type": 4 },
            "3271853210": { "Name": "WCT_SUPP", "Desc": "WCD_PI_SUPP", "Price": 1400, "Type": 3 }
        }
    },
    "1593441988": {
        "Count": 3,
        "Components": {
            "899381934": { "Name": "WCT_FLASH", "Desc": "WCD_FLASH", "Price": 400, "Type": 7 },
            "3271853210": { "Name": "WCT_SUPP", "Desc": "WCD_PI_SUPP", "Price": 600, "Type": 3 },
            "3328527730": { "Name": "WCT_VAR_GOLD", "Desc": "WCD_VAR_GOLD", "Price": 500, "Type": 1 }
        }
    },
    "2017895192": { "Count": 1, "Components": { "2242268665": { "Name": "WCT_VAR_METAL", "Desc": "WCD_VAR_METAL", "Price": 600, "Type": 1 } } },
    "2132975508": {
        "Count": 5,
        "Components": {
            "202788691": { "Name": "WCT_GRIP", "Desc": "WCD_GRIP", "Price": 900, "Type": 8 },
            "2076495324": { "Name": "WCT_FLASH", "Desc": "WCD_FLASH", "Price": 1200, "Type": 7 },
            "2205435306": { "Name": "WCT_SUPP", "Desc": "WCD_AR_SUPP", "Price": 700, "Type": 3 },
            "2824322168": { "Name": "WCT_VAR_METAL", "Desc": "WCD_VAR_BPR", "Price": 1600, "Type": 1 },
            "2855028148": { "Name": "WCT_SCOPE_SML", "Desc": "WCD_SCOPE_SML", "Price": 900, "Type": 4 }
        }
    },
    "3249783761": { "Count": 1, "Components": { "384708672": { "Name": "WCT_REV_VARB", "Desc": "WCD_REV_VARB", "Price": 1300, "Type": 1 }, "2492708877": { "Name": "WCT_REV_VARG", "Desc": "WCD_REV_VARG", "Price": 1000, "Type": 1 } } },
    "3675956304": { "Count": 1, "Components": { "3271853210": { "Name": "WCT_SUPP", "Desc": "WCD_PI_SUPP", "Price": 900, "Type": 3 } } },
    "3523564046": {
        "Count": 3,
        "Components": {
            "899381934": { "Name": "WCT_FLASH", "Desc": "WCD_FLASH", "Price": 900, "Type": 7 },
            "2053798779": { "Name": "WCT_VAR_WOOD", "Desc": "WCD_VAR_HPST", "Price": 1000, "Type": 1 },
            "3271853210": { "Name": "WCT_SUPP", "Desc": "WCD_PI_SUPP", "Price": 1100, "Type": 3 }
        }
    },
    "3342088282": {
        "Count": 5,
        "Components": {
            "202788691": { "Name": "WCT_GRIP", "Desc": "WCD_GRIP", "Price": 1400, "Type": 8 },
            "371102273": { "Name": "WCT_VAR_GOLD", "Desc": "WCD_VAR_MKRF", "Price": 3000, "Type": 1 },
            "471997210": { "Name": "WCT_SCOPE_LRG", "Desc": "WCD_SCOPE_LRF", "Price": 2300, "Type": 4 },
            "2076495324": { "Name": "WCT_FLASH", "Desc": "WCD_FLASH", "Price": 1300, "Type": 7 },
            "2205435306": { "Name": "WCT_SUPP", "Desc": "WCD_AR_SUPP", "Price": 1600, "Type": 3 }
        }
    },
    "2578377531": {
        "Count": 3,
        "Components": {
            "899381934": { "Name": "WCT_FLASH", "Desc": "WCD_FLASH", "Price": 400, "Type": 7 },
            "2008591151": { "Name": "WCT_VAR_SIL", "Desc": "WCD_VAR_SIL", "Price": 500, "Type": 1 },
            "2805810788": { "Name": "WCT_SUPP", "Desc": "WCD_AR_SUPP2", "Price": 600, "Type": 3 }
        }
    },
    "3220176749": {
        "Count": 5,
        "Components": {
            "202788691": { "Name": "WCT_GRIP", "Desc": "WCD_GRIP", "Price": 1200, "Type": 8 },
            "1319990579": { "Name": "WCT_VAR_GOLD", "Desc": "WCD_VAR_GOLD", "Price": 2000, "Type": 1 },
            "2076495324": { "Name": "WCT_FLASH", "Desc": "WCD_FLASH", "Price": 900, "Type": 7 },
            "2637152041": { "Name": "WCT_SCOPE_MAC", "Desc": "WCD_SCOPE_MAC", "Price": 1400, "Type": 4 },
            "2805810788": { "Name": "WCT_SUPP", "Desc": "WCD_AR_SUPP2", "Price": 1100, "Type": 3 }
        }
    },
    "2210333304": {
        "Count": 5,
        "Components": {
            "202788691": { "Name": "WCT_GRIP", "Desc": "WCD_GRIP", "Price": 1300, "Type": 8 },
            "2076495324": { "Name": "WCT_FLASH", "Desc": "WCD_FLASH", "Price": 900, "Type": 7 },
            "2205435306": { "Name": "WCT_SUPP", "Desc": "WCD_AR_SUPP", "Price": 1100, "Type": 3 },
            "2698550338": { "Name": "WCT_SCOPE_LRG", "Desc": "WCD_SCOPE_LRG", "Price": 1400, "Type": 4 },
            "3634075224": { "Name": "WCT_VAR_GOLD", "Desc": "WCD_VAR_GOLD", "Price": 2000, "Type": 1 }
        }
    },
    "2937143193": {
        "Count": 4,
        "Components": {
            "930927479": { "Name": "WCT_VAR_METAL", "Desc": "WCD_VAR_METAL", "Price": 2000, "Type": 1 },
            "2076495324": { "Name": "WCT_FLASH", "Desc": "WCD_FLASH", "Price": 900, "Type": 7 },
            "2205435306": { "Name": "WCT_SUPP", "Desc": "WCD_AR_SUPP", "Price": 1100, "Type": 3 },
            "2855028148": { "Name": "WCT_SCOPE_SML", "Desc": "WCD_SCOPE_SML", "Price": 1400, "Type": 4 }
        }
    },
    "2640438543": {
        "Count": 3,
        "Components": {
            "202788691": { "Name": "WCT_GRIP", "Desc": "WCD_GRIP", "Price": 400, "Type": 8 },
            "2076495324": { "Name": "WCT_FLASH", "Desc": "WCD_FLASH", "Price": 600, "Type": 7 },
            "2805810788": { "Name": "WCT_SUPP", "Desc": "WCD_AR_SUPP2", "Price": 800, "Type": 3 }
        }
    },
    "1432025498": {
        "Count": 5,
        "Components": {
            "1108334355": { "Name": "WCT_HOLO", "Desc": "WCD_HOLO", "Price": 1200, "Type": 4 },
            "77277509": { "Name": "WCT_SCOPE_MAC2", "Desc": "WCD_SCOPE_MAC", "Price": 1200, "Type": 4 },
            "1060929921": { "Name": "WCT_SCOPE_SML2", "Desc": "WCD_SCOPE_SML", "Price": 1200, "Type": 4 },
            "2076495324": { "Name": "WCT_FLASH", "Desc": "WCD_FLASH", "Price": 600, "Type": 7 },
            "2890063729": { "Name": "WCT_SUPP", "Desc": "WCD_SR_SUPP", "Price": 800, "Type": 3 },
            "1602080333": { "Name": "WCT_MUZZ8", "Desc": "WCD_MUZZ_SR", "Price": 1800, "Type": 5 },
            "3820854852": { "Name": "WCT_CAMO_1", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "387223451": { "Name": "WCT_CAMO_2", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "617753366": { "Name": "WCT_CAMO_3", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "4072589040": { "Name": "WCT_CAMO_4", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "8741501": { "Name": "WCT_CAMO_5", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "3693681093": { "Name": "WCT_CAMO_6", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "3783533691": { "Name": "WCT_CAMO_7", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "3639579478": { "Name": "WCT_CAMO_8", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "4012490698": { "Name": "WCT_CAMO_9", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "1739501925": { "Name": "WCT_CAMO_10", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "1178671645": { "Name": "WCT_CAMO_IND", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 }
        }
    },
    "2024373456": {
        "Count": 6,
        "Components": {
            "2076495324": { "Name": "WCT_FLASH", "Desc": "WCD_FLASH", "Price": 1200, "Type": 7 },
            "2681951826": { "Name": "WCT_HOLO", "Desc": "WCD_HOLO", "Price": 1500, "Type": 4 },
            "3842157419": { "Name": "WCT_SCOPE_MAC2", "Desc": "WCD_SCOPE_MAC", "Price": 1500, "Type": 4 },
            "1038927834": { "Name": "WCT_SCOPE_SML2", "Desc": "WCD_SCOPE_SML", "Price": 1500, "Type": 4 },
            "3271853210": { "Name": "WCT_SUPP", "Desc": "WCD_PI_SUPP", "Price": 1000, "Type": 3 },
            "3113485012": { "Name": "WCT_MUZZ1", "Desc": "WCD_MUZZ", "Price": 1800, "Type": 5 },
            "3362234491": { "Name": "WCT_MUZZ2", "Desc": "WCD_MUZZ", "Price": 1800, "Type": 5 },
            "3725708239": { "Name": "WCT_MUZZ3", "Desc": "WCD_MUZZ", "Price": 1800, "Type": 5 },
            "3968886988": { "Name": "WCT_MUZZ4", "Desc": "WCD_MUZZ", "Price": 1800, "Type": 5 },
            "48731514": { "Name": "WCT_MUZZ5", "Desc": "WCD_MUZZ", "Price": 1800, "Type": 5 },
            "880736428": { "Name": "WCT_MUZZ6", "Desc": "WCD_MUZZ", "Price": 1800, "Type": 5 },
            "1303784126": { "Name": "WCT_MUZZ7", "Desc": "WCD_MUZZ", "Price": 1800, "Type": 5 },
            "3641720545": { "Name": "WCT_BARR", "Desc": "WCD_BARR", "Price": 2100, "Type": 6 },
            "2774849419": { "Name": "WCT_BARR2", "Desc": "WCD_BARR2", "Price": 2100, "Type": 6 },
            "3298267239": { "Name": "WCT_CAMO_1", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "940943685": { "Name": "WCT_CAMO_2", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "1263226800": { "Name": "WCT_CAMO_3", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "3966931456": { "Name": "WCT_CAMO_4", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "1224100642": { "Name": "WCT_CAMO_5", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "899228776": { "Name": "WCT_CAMO_6", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "616006309": { "Name": "WCT_CAMO_7", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "2733014785": { "Name": "WCT_CAMO_8", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "572063080": { "Name": "WCT_CAMO_9", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "1170588613": { "Name": "WCT_CAMO_10", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 },
            "966612367": { "Name": "WCT_CAMO_IND", "Desc": "WCD_INVALID", "Price": 1100, "Type": 9 }
        }
    }
}